import { DetailRow } from '../../Compounds/DetailsDrawer/DetailRow';
import { DetailViewCard } from '../../Compounds/CardWithTitle';
import { ComponentSpinner } from '../../Compounds/Loading/ComponentSpinner';
import { AssetDetailField } from './useProjectAssetDetails';

export interface AssetDetailRowsProps {
  fields: AssetDetailField[];
  loading: boolean;
  // Lets the full-screen view lay the rows out in columns while the drawer keeps a single list.
  wrapperClass?: string;
}

// The asset field rows of a Details section — shared between the project-asset
// drawer and the 1 Project : 1 Asset full-screen page.
export const AssetDetailRows = ({ fields, loading, wrapperClass }: AssetDetailRowsProps) => {
  if (loading) {
    return (
      <div className="mt-32">
        <ComponentSpinner />
      </div>
    );
  }

  return (
    <div className={wrapperClass}>
      {fields.map((field) => (
        <DetailRow
          key={field.colId}
          colId={field.colId}
          title={field.title}
          value={field.value}
        />
      ))}
    </div>
  );
};

export interface AssetHistoryCardProps {
  notes?: string | null;
  collapsed?: boolean;
  bodyMaxHeightClass?: string;
  className?: string;
}

export const AssetHistoryCard = ({
  notes,
  collapsed = true,
  bodyMaxHeightClass = 'max-h-[30vh]',
  className
}: AssetHistoryCardProps) => (
  <DetailViewCard
    enableCollapse
    title="History"
    className={className}
    collapsed={collapsed}>
    <div className={`overflow-auto ${bodyMaxHeightClass} min-h-[2vh] text-black font-normal whitespace-pre-wrap`}>
      {notes || 'No history is available for this inventory record.'}
    </div>
  </DetailViewCard>
);
